import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';

@Component({
  standalone: true,
  selector: 'checkout-protection-start-summary-panel',
  templateUrl: './protection-start-summary-panel.component.html',
  styleUrls: ['./protection-start-summary-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, PanelComponent, RichTextComponent],
})
export class ProtectionStartSummaryPanelComponent {
  @Input() title?: string;
  @Input() body?: string;
  @Input() theme: Theme = 'decoration-color-5-alternative';
}
